import { LocaleMessages } from 'vue-i18n'

const APP_MESSAGES_APP_TITLE: string = process.env.VUE_APP_TITLE

const appEnUsLocaleMessages: LocaleMessages = {
  module: {
    app: APP_MESSAGES_APP_TITLE,
    auth: 'Authorization',
    bestzap: 'BestZap',
    doc: 'Documents',
    flp: 'Payroll',
    infra: 'Infrastructure',
    notacerta: 'Nota Certa',
    payment: 'Payments'
  },
  index: {
    field: {
      notifications: 'Notifications',
      settings: 'Settings',
      themeDark: 'Dark theme',
      language: 'Language',
      about: 'About',
      client: '{title} App',
      server: '{title} Server',
      menu: 'Menu'
    }
  },
  crud: {
    field: {
      pageInfo: '{start}-{stop} of {totalSize}',
      options: 'Options',
      auditingColumns: 'Auditing columns',
      refreshTable: 'Refresh table',
      itemsPerPage: 'Items per page',
      auditingInputs: 'Auditing inputs',
      refreshForm: 'Refresh form'
    },
    alert: {
      search: 'Search',
      select: 'Select a item',
      typeOrSelect: 'Type or select a item',
      typeAndPressTab: 'Type and press tab',
      delete: 'Are you sure you want to delete this item?',
      download: 'Are you sure you want to download all items?'
    },
    notification: {
      saved: 'Item successfully saved.',
      deleted: 'Item successfully deleted.'
    },
    button: {
      fetch: 'Fetch data',
      clear: 'Clear data'
    }
  },
  openExternal: {
    title: 'Open link'
  },
  routeNotFound: {
    title: 'Route not found'
  },
  viewNotImplemented: {
    title: 'View not implemented'
  },
  auditing: {
    field: {
      id: 'Id',
      version: 'Version',
      createdBy: 'Created by',
      createdDatetime: 'Created at',
      lastModifiedBy: 'Modified by',
      lastModifiedDatetime: 'Modified at'
    }
  },
  alert: {
    empty: 'No data available'
  },
  rule: {
    email: 'Enter a valid email.',
    max: 'This field must contain at most {0} characters.',
    min: 'This field must contain at least {0} characters.',
    required: 'This field is required.'
  },
  notification: {
    updateServiceWorker: 'New update available.',
    updatedServiceWorker: 'App successfully updated.',
    requestNotificationPermission: 'Receive server notifications.',
    grantedNotificationPermission: 'Notifications successfully enabled.'
  },
  error: {
    status404: 'Data not found.',
    requestCanceledError: 'Request canceled by the user.',
    networkError: 'Could not connect to server.'
  },
  button: {
    ok: 'OK',
    enable: 'Enable',
    update: 'Update',
    download: 'Download',
    enter: 'Enter',
    exit: 'Exit',
    send: 'Send',
    confirm: 'Confirm',
    create: 'Create',
    search: 'Search',
    open: 'Open',
    new: 'New',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel'
  },
  value: {
    enabledDisabled: {
      true: 'Enabled',
      false: 'Disabled'
    },
    connectedDisconnected: {
      true: 'Connected',
      false: 'Disconnected'
    },
    visibleHidden: {
      true: 'Visible',
      false: 'Hidden'
    }
  },
  vuetify: {
    badge: 'Badge',
    close: 'Close',
    dataIterator: {
      noResultsText: 'No items found',
      loadingText: 'Loading data...'
    },
    dataTable: {
      itemsPerPageText: 'Items per page',
      ariaLabel: {
        sortDescending: 'Sorted descending.',
        sortAscending: 'Sorted ascending.',
        sortNone: 'Not sorted.',
        activateNone: 'Activate to remove sorting.',
        activateDescending: 'Activate to sort descending.',
        activateAscending: 'Activate to sort ascending.'
      },
      sortBy: 'Sort by'
    },
    dataFooter: {
      itemsPerPageText: 'Items per page',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} of {2}'
    },
    datePicker: {
      itemsSelected: '{0} selected',
      nextMonthAriaLabel: 'Next month',
      nextYearAriaLabel: 'Next year',
      prevMonthAriaLabel: 'Previous month',
      prevYearAriaLabel: 'Previous year'
    },
    noDataText: 'No data available',
    carousel: {
      prev: 'Previous',
      next: 'Next',
      ariaLabel: {
        delimiter: 'Carousel slide {0} of {1}'
      }
    },
    calendar: {
      moreEvents: '{0} more'
    },
    fileInput: {
      counter: '{0} files',
      counterSize: '{0} files ({1} in total)'
    },
    timePicker: {
      am: 'AM',
      pm: 'PM'
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Pagination Navigation',
        next: 'Next page',
        previous: 'Previous page',
        page: 'Goto Page {0}',
        currentPage: 'Current Page: {0}'
      }
    },
    rating: {
      ariaLabel: {
        icon: 'Rating {0} of {1}'
      }
    }
  }
}

export default appEnUsLocaleMessages